<template>
  <a-alert
    v-if="state"
    class="banner"
    show-icon
    :type="state.open ? 'warning' : 'info'"
    :message="text.title"
    :description="text.detail"
  >
    <template #action>
      <a-space>
        <a-popconfirm v-if="state.open" title="游戏已经开服了吗？关闭后，升级、重装、重启节点会再次被锁定。" ok-text="已开服，关闭" cancel-text="取消" @confirm="run(closeMaintenance, '维护窗口已关闭')">
          <a-button type="primary" size="small" :loading="busy">已开服，关闭窗口</a-button>
        </a-popconfirm>
        <a-popconfirm v-if="state.override" title="撤销手动设置，回到每周四 06:00 的默认安排？" ok-text="撤销" cancel-text="取消" @confirm="run(clearMaintenanceOverride, '已恢复默认安排')">
          <a-button size="small" :loading="busy">恢复默认</a-button>
        </a-popconfirm>
        <a-popconfirm v-if="!state.open" title="临时开启 4 小时维护窗口？期间可以升级、重装、重启节点。" ok-text="开启 4 小时" cancel-text="取消" @confirm="run(() => openMaintenance(4), '维护窗口已开启 4 小时')">
          <a-button size="small" :loading="busy">临时开启</a-button>
        </a-popconfirm>
      </a-space>
    </template>
  </a-alert>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { message } from 'ant-design-vue';
import { clearMaintenanceOverride, closeMaintenance, openMaintenance } from '../api/health';
import type { MaintenanceState } from '../types';
import { maintenanceText } from './healthPresentation';

const props = defineProps<{ state: MaintenanceState | null }>();
const emit = defineEmits<{ (e: 'changed', state: MaintenanceState): void }>();

const busy = ref(false);
const text = computed(() => (props.state ? maintenanceText(props.state) : { title: '', detail: '' }));

const run = async (call: () => Promise<{ data: MaintenanceState }>, success: string) => {
  if (busy.value) return;
  busy.value = true;
  try {
    const { data } = await call();
    message.success(success);
    emit('changed', data);
  } catch (e: any) {
    message.error(e?.response?.data?.error?.message || e?.message || '操作失败');
  } finally {
    busy.value = false;
  }
};
</script>

<style scoped>
.banner { margin-bottom: 16px; }
</style>
